import { render, staticRenderFns } from "./ChartShippingCost.vue?vue&type=template&id=d066eb0a&"
import script from "./ChartShippingCost.vue?vue&type=script&lang=js&"
export * from "./ChartShippingCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports